import { useState, useEffect } from 'react';

const Appearance = () => {
    const [darkMode, setDarkMode] = useState(false);
    const [notifications, setNotifications] = useState(true);

    // Effect to set initial dark mode state from localStorage
    useEffect(() => {
        const isDarkMode = localStorage.getItem("darkMode") === "true";
        setDarkMode(isDarkMode);
        if (isDarkMode) {
            document.documentElement.classList.add("dark");
        }
    }, []);

    const handleDarkModeToggle = (e) => {
        const isChecked = e.target.checked;
        setDarkMode(isChecked);
        localStorage.setItem("darkMode", String(isChecked));
        if (isChecked) {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
    };

    return (
        <div className="bg-white dark:bg-neutral-800 rounded-lg p-6 shadow-sm">
            <h2 className="text-xl font-semibold text-neutral-800 dark:text-white mb-4">Appearance & Notifications</h2>
            <div className="space-y-4">
                <div className="flex items-center justify-between">
                    <label htmlFor="darkModeToggle" className="text-neutral-700 dark:text-neutral-300">
                        Dark Mode
                    </label>
                    <input
                        id="darkModeToggle"
                        type="checkbox"
                        className="toggle toggle-primary"
                        checked={darkMode}
                        onChange={handleDarkModeToggle}
                    />
                </div>
            </div>
        </div>
    );
};

export default Appearance;
